import { faFlag, faFontAwesomeFlag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import { SelectedQuestion } from '../../view/Private/Exam/context';


interface IOptionTrueFalseWithNooption {
    choiceLabel: any
    count: number
    onChange: any
    optionId: string
    defaultValue?: any
    trueorfalsewithdontknow?: any
}

export default function OptionTrueFalseWithNooption(props: IOptionTrueFalseWithNooption) {
    
    const { selectedQuestionId, setSelectedQuestionId } = useContext<any>(SelectedQuestion);


    const [isSelected, setSelected] = useState <undefined | 'yes' | 'no' | 'dontknow'> (props.defaultValue && props.defaultValue.value);

    useEffect(() => {
        props.onChange({
            optionId: props.optionId,
            value: isSelected
        });
    }, [isSelected, selectedQuestionId]);

    const handleChange = (e: any, value: any) => {
        if(isSelected == value) { 
            setSelected(undefined);
        }
        else{
            setSelected(value)
        }
    }


    useEffect(()=>{
        if(props.defaultValue && props.defaultValue.value === "yes"){
            setSelected("yes")
        }
        else if (props.defaultValue && props.defaultValue.value === "no"){
            setSelected("no")
        } 
        else if(props.defaultValue && props.defaultValue.value === "dontknow"){
            setSelected("dontknow")
        }
        else{
            setSelected(undefined)
        }

    },[props.defaultValue])


    return (
        <div className="mb-2">
            <span className='fw-bold fs-6 mb-2'> {String((props.count)+ ".")} {props.choiceLabel}</span>
            {/* <span className='fw-bold fs-6 mb-2'> {String((props.count + 9).toString(36).toUpperCase() + ".")} {props.choiceLabel}</span> */}
            <Form.Group>
                <Form.Check
                    onClick={(e: any) => handleChange(e, "yes")}
                    // checked={isSelected}
                    type="radio"
                    checked={isSelected == 'yes' ? true : false}
                    label={<div className="h5 d-flex justify-content-end align-items-center">
                        {"True"}
                    </div>}
                />
                <Form.Check
                    onClick={(e: any) => handleChange(e, "no")}
                    // checked={isSelected}
                    type="radio"
                    checked={isSelected == "no" ? true : false}
                    label={<div className="h5 d-flex justify-content-end align-items-center">
                       {"False"}
                    </div>}
                />
                  <Form.Check
                    onClick={(e: any) => handleChange(e, "dontknow")}
                    // checked={isSelected}
                    type="radio"
                    checked={isSelected == "dontknow" ? true : false}
                    label={<div className="h5 d-flex justify-content-end align-items-center">
                        {"Don't Know"}
                    </div>}
                />
            </Form.Group>
        </div>
    )
}